import React from 'react'
import { StyledLinks } from './styled'

const links = [
  { name: 'トップ', href: '#' },
  { name: 'サービスの特徴', href: '#service-features' },
  { name: 'ご利用の流れ', href: '#service-flow' },
  { name: 'よくある質問一覧', href: '/faq' },
  { name: 'お知らせ一覧', href: '/information' },
]

const jobOfferLinks = [
  { name: 'バックエンドエンジニア', to: '/job_offers/o/7' },
  { name: 'フロントエンドエンジニア', to: '/job_offers/o/4' },
  { name: 'Web・UI/UXデザイナー', to: '/job_offers/o/20' },
  { name: 'Webディレクター', to: '/job_offers/o/45' },
]

const otherLinks = [
  { name: '利用規約', href: '/terms' },
  { name: 'サイトマップ', href: '/sitemap' },
]

export const Links: React.FC = () => {
  return (
    <StyledLinks links={links} jobOfferLinks={jobOfferLinks} otherLinks={otherLinks} />
  )
}
